import request from '@/utils/request'
const recruitServer = ''

/** 查询字典列表
 * params getDict
 * params dictTypes String 支持多个字典查询，逗号隔开
*/
export function getDict (dictTypes) {
  const dictTypesString = dictTypes?.join(',')
  return request({
    url: `${recruitServer}/common/getDictByTypes?dictTypes=` + dictTypesString,
    method: 'get'
  })
}

/**
 * 查询民族列表
 * @param {*}
 * @returns 
 */
export function getNation () {
  return request({
    url: `${recruitServer}/common/getNationDicts`,
    method: 'get'
  })
}

/**
 * 查询省份列表
 * @param {*}
 * @returns 
 */
export function getProvince () {
  return request({
    url: `${recruitServer}/common/getProvince`,
    method: 'get'
  })
}

/**
 * 根据省份
 * 查询市列表
 * @param {*}
 * @returns 
 */
export function getCitys (province) {
  return request({
    url: `${recruitServer}/common/getCitys?province=` + province,
    method: 'get'
  })
}

/**
 * 取全部省市区数据字典
 * @returns {AxiosPromise}
 */
export function getRegions () {
  return request({
    url: `${recruitServer}/common/getRegions`,
    method: 'get'
  })
}
